import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as contractApi from "../api/contract.api"

const formatOptions = (data) => {
  return data.map(item => ({
    label: item.slug,
    text: item.name,
    title: item.name,
    value: item.slug,
    ...item
  }))
}

const formatDueDays = (data) => {
  return data.map(item => ({
    text: `${item}`,
    value: item
  }))
}

export const listAccessionsByCity = async uuid => {
  try {
    const { data } = await contractApi.listAccessionsByCity(uuid)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: error?.response?.data?.message || "Falha ao listar promoções."
    })
  }
}

export const listSaleOrigins = async params => {
  try {
    const data = await contractApi.listSaleOrigins(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar tipos de captação."
    })
    throw error
  }
}

export const fetchDueDays = async () => {
  try {
    const { data } = await contractApi.fetchDueDays()
    return formatDueDays(data?.due_days)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar datas disponíveis."
    })
  }
}

export const fetchContractTypes = async params => {
  try {
    const { data } = await contractApi.fetchContractTypes(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar datas disponíveis."
    })
  }
}

export const fetchAccessionByCity = async params => {
  try {
    const { data } = await contractApi.fetchAccessionByCity(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message ||
        "Falha ao listar as adesões disponíveis."
    })
  }
}

export const listClientContracts = async document => {
  try {
    const { data } = await contractApi.listClientContracts(document)
    return data
  } catch (error) {
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Falha ao obter contratos."
    })
    throw error
  }
}

export const fetchPaymentType = async params => {
  try {
    const { data } = await contractApi.fetchPaymentType(params)
    return formatOptions(data)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar formas de pagamento."
    })
  }
}

export const fetchShippingMethod = async params => {
  try {
    const { data } = await contractApi.fetchShippingMethod(params)
    return formatOptions(data)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar formas de envio."
    })
  }
}

export const listServiceOrigin = async () => {
  try {
    const { data } = await contractApi.listServiceOrigin()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message || "Falha ao listar origens de serviço."
    })
  }
}
